import InputField from "@components/FormControls/CatalystTextField";

import { Button } from "@components/Catalyst/button";
import { yupResolver } from "@hookform/resolvers/yup";
import { LoginSchema, loginSchema } from "@validators/auth";
import React from "react";
import { useForm } from "react-hook-form";
import { Fieldset, FieldGroup } from "@components/Catalyst/fieldset";
import { login } from "@contexts/AuthContext/functions/login";
import toast from "react-hot-toast";

const LoginForm = ({ email, setEmail }: { email: string; setEmail: (modalEmail: string) => void }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isSubmitting },
  } = useForm<LoginSchema>({ resolver: yupResolver(loginSchema), defaultValues: { email }, mode: "onChange" });

  const onSubmit = async (data: LoginSchema) => {
    toast.loading("Signing In...", { id: "auth-status" });
    setEmail(data.email);
    await login(data.email, data.password);
    toast.dismiss("auth-status");
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Fieldset>
        <FieldGroup>
          <InputField
            className="max-w-sm"
            label="Email"
            autocomplete="username"
            register={register}
            name="email"
            type="email"
            error={errors.email}
            required
          />
          <InputField
            className="max-w-sm"
            label="Password"
            register={register}
            name="password"
            type="password"
            autocomplete="current-password"
            error={errors.password}
            required
            isPassword
          />

          <Button type="submit" disabled={!isValid || isSubmitting}>
            Sign In
          </Button>
        </FieldGroup>
      </Fieldset>
    </form>
  );
};

export default LoginForm;
